import React from "react";
import { motion } from "framer-motion";
import logoImg from "../assets/images/logo.png";

const Loader = ({ fullScreen = true }) => {
  return (
    <div className={`flex justify-center items-center bg-white ${fullScreen ? "min-h-screen" : "min-h-[50vh]"}`}>
      <motion.div
        className="flex flex-col items-center gap-5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <motion.img
          src={logoImg}
          alt="Prasoon Logo"
          className="h-28 w-auto"
          animate={{ scale: [1, 1.1, 1], opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        />
        
        <p className="text-sm font-medium text-gray-400 uppercase tracking-widest">
          Loading
        </p>
      </motion.div>
    </div>
  );
};

export default Loader;
